package com.patronat.top.features.dashboard.di


import com.patronat.top.features.dashboard.data.network.DashboardRemoteDataStore
import com.patronat.top.features.dashboard.data.network.ReviewModerationRemoteDataStore
import com.patronat.top.features.dashboard.data.repository.DashboardRepositoryImpl
import com.patronat.top.features.dashboard.data.repository.ReviewModerationRepositoryImpl
import com.patronat.top.features.dashboard.domain.repository.DashboardRepository
import com.patronat.top.features.dashboard.domain.repository.ReviewModerationRepository
import com.patronat.top.features.dashboard.domain.usecase.GetDashboardStatsUseCase
import com.patronat.top.features.dashboard.domain.usecase.GetOwnerReviewsUseCase
import com.patronat.top.features.dashboard.domain.usecase.GetReviewModerationQueueUseCase
import com.patronat.top.features.dashboard.domain.usecase.ModerateReviewUseCase
import com.patronat.top.features.dashboard.domain.usecase.ReplyToOwnerReviewUseCase
import com.patronat.top.features.usermanagement.domain.usecase.GetCurrentUserUseCase
import com.patronat.top.features.dashboard.presentation.ownerreviews.OwnerReviewsViewModel
import com.patronat.top.features.dashboard.presentation.reviewmoderation.ReviewAiModerationViewModel
import com.patronat.top.features.dashboard.presentation.viewmodel.DashboardViewModel
import org.koin.dsl.module

val dashboardModule = module {

    single { DashboardRemoteDataStore(get()) }
    single<DashboardRepository> { DashboardRepositoryImpl(get()) }
    single { ReviewModerationRemoteDataStore(get()) }
    single<ReviewModerationRepository> { ReviewModerationRepositoryImpl(get()) }

    single {
        GetCurrentUserUseCase(
            userRepository = get(),
            dispatcherProvider = get()
        )
    }
    single { GetDashboardStatsUseCase(dashboardRepository = get(), dispatcherProvider = get()) }
    single { GetReviewModerationQueueUseCase(repository = get(), dispatcherProvider = get()) }
    single { ModerateReviewUseCase(repository = get(), dispatcherProvider = get()) }
    single { GetOwnerReviewsUseCase(repository = get(), dispatcherProvider = get()) }
    single { ReplyToOwnerReviewUseCase(repository = get(), dispatcherProvider = get()) }

    factory<DashboardViewModel> {
        DashboardViewModel(
            alertController = get(),
            getCurrentUserUseCase = get(),
            getDashboardStatsUseCase = get()
        )
    }

    factory<ReviewAiModerationViewModel> {
        ReviewAiModerationViewModel(
            alertController = get(),
            getReviewModerationQueueUseCase = get(),
            moderateReviewUseCase = get(),
            getVenueByIdUseCase = get()
        )
    }

    factory<OwnerReviewsViewModel> {
        OwnerReviewsViewModel(
            alertController = get(),
            getOwnerReviewsUseCase = get(),
            replyToOwnerReviewUseCase = get(),
            getVenueByIdUseCase = get()
        )
    }
}
